










































import { Mixins, Component } from "vue-property-decorator";
import { HisInformationSetting } from "../../../../../../../base/domain/his";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { HisInformationItemTypeSelector, HisInformationItemSelector } from "../selectors";
import { IHisInformationTreeData } from "../../../../../../domain/editableFormat";

@Component({
  components: {
    typeSelector: HisInformationItemTypeSelector,
    hisInformationItemSelector: HisInformationItemSelector,
  }
})
export default class HisInformationTypeItemSelectDialog extends Mixins(DialogMixin) {
  data() {
    return {
      selectedItem: null as HisInformationSetting,
      confirmSelected: false,
      hisInformationItems: [] as HisInformationSetting[],
      displayHisInformationItems: [] as HisInformationSetting[],
    };
  }
  selectedItem: HisInformationSetting;
  confirmSelected: boolean;
  hisInformationItems: HisInformationSetting[];
  displayHisInformationItems: HisInformationSetting[];

  $refs!: {
    typeSelector: HisInformationItemTypeSelector,
    itemSelector: HisInformationItemSelector,
  };

  async show(data: HisInformationSetting[], selected: HisInformationSetting): Promise<HisInformationSetting> {
    return this.showModal(async () => {
      this.confirmSelected = false;
      this.displayHisInformationItems = [];
      this.selectedItem = null;

      this.hisInformationItems = data;
      await this.$nextTick();
      if (this.$refs.typeSelector) {
        this.$refs.typeSelector.changeSelection(selected.itemType);
      }
      await this.$nextTick();
      if (this.$refs.itemSelector) {
        this.$refs.itemSelector.changeSelection(selected);
      }
      await this.waitHidden();
      return this.confirmSelected ? this.selectedItem : null;
    });
  }

  get isSelected(): boolean {
    return !!this.selectedItem;
  }

  get explanation(): string {
    return !this.selectedItem ? "" : this.createExplanation();
  }

  private createExplanation(): string {
    let text = "";
    text += "【説明】\r\n" + this.selectedItem.explanation + "\r\n\r\n";
    text += "【設定箇所】\r\n" + this.createSetPlaceTypeText(this.selectedItem.setPlaceType) + "\r\n\r\n";
    text += "【患者情報の再読み込み】\r\n" + this.createReloadTypeText(this.selectedItem.reloadType) + "\r\n\r\n";
    text += "【選択画面】\r\n" + this.createScreenTypeText(this.selectedItem.screenType) + "\r\n\r\n";
    text += "【行数】 " + (this.selectedItem.objectType === "TEXTAREA" ? "複数" : "単一") + "\r\n";
    text += "【編集】 " + (this.selectedItem.edit ? "可" : "不可") + "\r\n";
    text += "【フリー入力】 " + (this.selectedItem.isFreeInput ? "可" : "不可") + "\r\n";
    text += "【引用・転記】 " + (this.selectedItem.isReplace ? "可" : "不可");
    return text;
  }

  updateSelectedType(value: IHisInformationTreeData) {
    this.displayHisInformationItems = (!value || (value.source instanceof HisInformationSetting)) 
      ? [] : value.source.entities;
  }

  updateSelectedHisInformationItem(value: HisInformationSetting) {
    this.selectedItem = value;
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }

  private createSetPlaceTypeText(type: string): string {
    switch (type) {
      case "EDIT_START_FIRST": return "記載開始(初回作成時)";
      case "EDIT_START": return "記載開始";
      case "PRINT": return "印刷";
      case "NO_SAVE_PRINT": return "登録なしの印刷";
      case "SAVE_FILE": return "ファイル保存";
      case "SAVE_PDF": return "PDF保存";
      case "SAVE_REPORT": return "書類保存";
      case "WORKFLOW_REQUEST": return "ワークフローの依頼時";
      case "WORKFLOW_RECONGNIZE": return "ワークフローの承認";
      case "WORKFLOW_CONFIG": return "直接記載時\r\n記載開始(初回作成時)\r\nワークフロー(設定による)\r\nワークフローの依頼\r\n最終書類作成ステータスの記載開始";
      case "OTHER_EDIT_START": return "記載開始時以外（印刷・ファイル保存・PDF保存・書類保存）";
      case "WORKFLOW_REQUEST_FIRST_EDIT ": return "ワークフローの初回作成時（ワークフローの依頼時・ワークフローの初回記載時）";
      default: return "";
    }
  }

  private createReloadTypeText(type: string): string {
    switch (type) {
      case "NONE": return "対象外";
      case "AUTO": return "自動設定";
      case "MANUAL": return "任意設定";
      case "MANUAL_AUTO": return "任意設定（設定により自動設定）";
      default: return "";
    }
  }

  private createScreenTypeText(type: string): string {
    switch (type) {
      case "NONE": return "選択画面なし";
      case "LIST": return "リスト画面";
      case "DEPARTMENT": return this.$wording.common.department + "選択画面";
      case "DOCTOR": return "医師選択画面";
      case "HOSP_DESTINATION": return "他病院情報選択画面";
      default: return "";
    }
  }
}
